import React, { useEffect, useState } from 'react';

const MonitorClock = () => {
  const [date, setDate] = useState(() => new Date());

  useEffect(() => {
    const interval = window.setInterval(() => setDate(new Date()), 1000);
    return () => window.clearInterval(interval);
  }, []);

  return <span id="date-value">{date.toLocaleString()}</span>;
};

export default MonitorClock;
